import React, { useEffect, lazy, Suspense, useState } from "react";

//react-router-dom
import { Switch, Route, useHistory, Redirect } from "react-router-dom";

//react-redux
import { useDispatch, useSelector } from "react-redux";

// css
import "./Component/assets/css/bootstrap.min.css";
import "./Component/assets/css/typography-dark.css";
import "./Component/assets/css/style.css";
import "./Component/assets/css/responsive.css";
import "./Component/assets/css/admin-shell-responsive.css";
import "./Component/assets/js/chartist/chartist.min.css";
import "./Component/assets/css/variable.css";
import "./Component/assets/css/ionicons.min.css";
import "./Component/assets/css/line-awesome.min.css";
import "./Component/assets/css/fontawesome.css";
import "./Component/assets/css/remixicon.css";
import "./Component/assets/css/livetv.css";
import "./Component/assets/css/liveTvProgram.css";

//js bewww
import "./Component/assets/js/custom.js";
import "./Component/assets/js/jquery.min.js";
import "./Component/assets/js/rtl.js";
import "./Component/assets/js/customizer.js";
import "./Component/assets/js/popper.min.js";
import "./Component/assets/js/bootstrap.min.js";
import "./Component/assets/js/jquery.appear.js";
import "./Component/assets/js/countdown.min.js";
import "./Component/assets/js/waypoints.min.js";
import "./Component/assets/js/jquery.counterup.min.js";
import "./Component/assets/js/wow.min.js";
import "./Component/assets/js/apexcharts.js";
import "./Component/assets/js/slick.min.js";
import "./Component/assets/js/select2.min.js";
import "./Component/assets/js/jquery.magnific-popup.min.js";
import "./Component/assets/js/smooth-scrollbar.js";
import "./Component/assets/js/lottie.js";
import "./Component/assets/js/core.js";
import "./Component/assets/js/charts.js";
import "./Component/assets/js/animated.js";
import "./Component/assets/js/kelly.js";
import "./Component/assets/js/morris.js";
import "./Component/assets/js/maps.js";
import "./Component/assets/js/worldLow.js";
import "./Component/assets/js/chartist/chartist.min.js";
import "./Component/assets/js/chart-custom.js";
import "react-big-calendar/lib/css/react-big-calendar.css";

//Types
import { UNSET_ADMIN, UPDATE_PROFILE } from "./store/Admin/admin.type";
import { apiInstanceFetch } from "./util/api";
import { confirmSession, getSession, revokeSession } from "./util/authSession";

import { IdleTimeoutManager } from "idle-timer-manager";
import Loader from "../src/Pages/Loader";
import { ToastContainer } from "react-toastify";
import VideoPlayer from "./Pages/hls/VideoPlayer.js";
import PrivacyPolicy from "./Pages/PrivacyPolicy.js";
import TermsAndCondition from "./Pages/TermsAndCondition.js";
import ShakaDrmPlayer from "./Pages/hls/ShakaDrmPlayer.js";
import MuxPlayerComponent from "./Component/MuxPlayer/MuxPlayerComponent";
import { ROLES } from "./constants/index.js";
import { subdomainAdmin, subdomainContentCreator } from "./util/config";
import { initializeNotifications } from "./util/NotificationService.js";

//component
const Login = lazy(() => import("./Pages/Login"));
const ForgotPassword = lazy(() => import("./Pages/ForgotPassword"));
const ChangePassword = lazy(() => import("./Pages/ChangePassword"));
const Admin = lazy(() => import("./Pages/Admin"));
const ContentCreatorRoutes = lazy(() =>
  import("./Pages/content-creator.routes.js")
);

const AuthRouter = lazy(() => import("./util/AuthRoute"));
const ProtectedRoute = lazy(() => import("./util/ProtectedRoute"));

// content-creator
const ContentCreatorSignUp = lazy(() =>
  import("./Pages/content-creator/SignUp")
);
const Profile = lazy(() => import("./Pages/content-creator/Profile"));
const CreatorLogin = lazy(() => import("./Pages/content-creator/Login"));
const SubmitYourDetails = lazy(() =>
  import("./Pages/content-creator/SubmitYourDetails")
);

function App() {
  const dispatch = useDispatch();
  const { isAuth, admin } = useSelector((state) => state.admin);
  // Who is signed in comes from the session summary (the tokens themselves are
  // HttpOnly cookies the page cannot read). Keyed on the account, so the boot
  // work below runs again only when a different account signs in.
  const sessionAccount = isAuth ? admin?.adminId || admin?.email || "signed-in" : "";
  const sessionRole = isAuth ? admin?.role || "" : "";
  const [login] = useState(false);
  const history = useHistory();

  // Confirm the stored session with the API once per page load (refreshing the
  // cookies when the access token has expired). If it is over, the session
  // summary is cleared and the route guards send the user to /login.
  useEffect(() => {
    confirmSession();
  }, []);

  useEffect(() => {
    const manager = new IdleTimeoutManager({
      timeout: 3600, //60 min (in sec)
      onExpired: (time) => {
        if (!getSession()) return;
        revokeSession();
        dispatch({ type: UNSET_ADMIN });
        history.push("/login");
      },
    });

    return () => {
      manager.clear();
    }; //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!sessionAccount) return;

    // GET /admin/profile is authorize([ADMIN, SUB_ADMIN]) on the API, so for a
    // content creator it can only ever 403 — it has never returned them
    // anything. Firing it on every boot just to throw the result away is a
    // guaranteed failing request on the creator panel's critical path, so skip
    // it for that role entirely.
    //
    // `false` = no blocking spinner for the roles that do call it. This is a
    // background refresh nothing on screen waits for; letting it open the
    // full-screen loader Dialog meant a slow or stalled response greyed out and
    // froze whatever page the user had just landed on.
    if (sessionRole !== ROLES.CONTENT_CREATOR) {
      apiInstanceFetch
        .get("admin/profile", false)
        .then((profileRes) => {
          if (profileRes?.admin) {
            dispatch({ type: UPDATE_PROFILE, payload: profileRes.admin });
          }
        })
        .catch(() => {});
    }

    initializeNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionAccount]);

  return (
    <>
      <div className="wrapper">
        <Suspense fallback={<div></div>}>
          {/* Subdomain Routing Logic */}
          {(() => {
            const getSubdomain = () => {
              const hostname = window.location.hostname;
              const parts = hostname.split(".");
              // Handle localhost: admin.localhost
              if (hostname.includes("localhost") && parts.length === 2 && parts[0] !== "www") return parts[0];
              // Handle production: admin.nabtt.com
              if (parts.length > 2 && parts[0] !== "www") return parts[0];
              return null;
            };

            const subdomain = getSubdomain();

            if (subdomain && subdomain.includes(subdomainAdmin)) {
              return (
                <Switch>
                  <AuthRouter
                    exact
                    path="/login"
                    component={Login}
                    accessRole={[ROLES.ADMIN, ROLES.SUB_ADMIN]}
                  />
                  <AuthRouter exact path="/forgotPassword" component={ForgotPassword} />
                  <Route exact path="/changePassword" component={ChangePassword} />
                  <Route path="/changePassword/:id" component={ChangePassword} />

                  {/* Common Routes */}
                  <Route path="/player" component={VideoPlayer} />
                  <Route path="/shaka-drm" component={ShakaDrmPlayer} />
                  <Route path="/privacy-policy" component={PrivacyPolicy} />
                  <Route path="/terms-and-condition" component={TermsAndCondition} />
                  <Route path="/mux-player" component={MuxPlayerComponent} />

                  {/* Admin Main Routes */}
                  {/* Legacy Support for hardcoded paths */}
                  <ProtectedRoute
                    path="/admin"
                    component={Admin}
                    accessRole={[ROLES.ADMIN, ROLES.SUB_ADMIN]}
                  />
                  {/* Mount Admin at root for subdomain */}
                  <ProtectedRoute
                    path="/"
                    component={Admin}
                    accessRole={[ROLES.ADMIN, ROLES.SUB_ADMIN]}
                  />

                  <Route path="*">
                    {isAuth ? (
                      <Redirect to="/admin/dashboard" />
                    ) : (
                      <Redirect to="/login" />
                    )}
                  </Route>
                </Switch>
              );
            } else if (subdomain && subdomain.includes(subdomainContentCreator)) {
              return (
                <Switch>
                  <AuthRouter
                    exact
                    path="/login"
                    component={CreatorLogin}
                    redirect={"/submit-your-details"}
                    accessRole={[ROLES.CONTENT_CREATOR]}
                  />
                  <Route
                    exact
                    path="/signup"
                    component={ContentCreatorSignUp}
                  />
                  <ProtectedRoute
                    exact
                    path="/submit-your-details"
                    component={SubmitYourDetails}
                    accessRole={[ROLES.CONTENT_CREATOR]}
                  />
                  <Route
                    exact
                    path="/edit/profile/:id"
                    component={Profile}
                  />

                  <AuthRouter exact path="/forgotPassword" component={ForgotPassword} />
                  <Route exact path="/changePassword" component={ChangePassword} />
                  <Route path="/changePassword/:id" component={ChangePassword} />

                  {/* Common Routes */}
                  <Route path="/player" component={VideoPlayer} />
                  <Route path="/shaka-drm" component={ShakaDrmPlayer} />
                  <Route path="/privacy-policy" component={PrivacyPolicy} />
                  <Route path="/terms-and-condition" component={TermsAndCondition} />
                  <Route path="/mux-player" component={MuxPlayerComponent} />

                  {/* Content Creator Main Routes */}
                  {/* Legacy Support */}
                  <ProtectedRoute
                    path="/content-creator"
                    component={ContentCreatorRoutes}
                    accessRole={[ROLES.CONTENT_CREATOR]}
                  />
                  <ProtectedRoute
                    path="/"
                    component={ContentCreatorRoutes}
                    accessRole={[ROLES.CONTENT_CREATOR]}
                  />

                  <Route path="*">
                    {isAuth ? (
                      <Redirect to="/content-creator/profile/admin_info" />
                    ) : (
                      <Redirect to="/login" />
                    )}
                  </Route>
                </Switch>
              );
            } else {
              // Legacy / Main Domain Behavior
              return (
                <Switch>
                  <AuthRouter exact path="/" component={Login} />
                  <AuthRouter exact path="/login" component={Login} accessRole={[ROLES.ADMIN, ROLES.SUB_ADMIN]} />

                  <AuthRouter
                    exact
                    path="/content-creator/login"
                    component={CreatorLogin}
                    redirect={"/submit-your-details"}
                    accessRole={[ROLES.CONTENT_CREATOR]}
                  />
                  <Route
                    exact
                    path="/content-creator/signup"
                    component={ContentCreatorSignUp}
                  />
                  <ProtectedRoute
                    exact
                    path="/submit-your-details"
                    component={SubmitYourDetails}
                    accessRole={[ROLES.CONTENT_CREATOR]}
                  />
                  <Route
                    exact
                    path="/content-creator/edit/profile/:id"
                    component={Profile}
                  />

                  <AuthRouter
                    exact
                    path="/forgotPassword"
                    component={ForgotPassword}
                  />

                  <Route exact path="/changePassword" component={ChangePassword} />
                  <Route path="/changePassword/:id" component={ChangePassword} />

                  {/* Admin Routes */}
                  <ProtectedRoute
                    path="/admin"
                    component={Admin}
                    accessRole={[ROLES.ADMIN, ROLES.SUB_ADMIN]}
                  />

                  <ProtectedRoute
                    path="/content-creator"
                    component={ContentCreatorRoutes}
                    accessRole={[ROLES.CONTENT_CREATOR]}
                  />

                  <Route path="/player" component={VideoPlayer} />
                  <Route path="/shaka-drm" component={ShakaDrmPlayer} />
                  <Route path="/privacy-policy" component={PrivacyPolicy} />
                  <Route path="/terms-and-condition" component={TermsAndCondition} />
                  <Route path="/mux-player" component={MuxPlayerComponent} />

                  {/* Catch-all */}
                  <Route path="*">
                    {isAuth ? (
                      <Redirect to="/admin/dashboard" />
                    ) : (
                      <Redirect to="/login" />
                    )}
                  </Route>
                </Switch>
              );
            }
          })()}
          <Loader />
        </Suspense>
        <ToastContainer />
      </div>
    </>
  );
}

export default App;

